import { CertificazioneCellulareDto, CertificazioneEmailDto, CertificazioneUtenteDto, DettaglioCertificazioneDto, LogCertificazioneAnagrafeCedacriDto } from "@desio/api";
import { createSelector } from "@reduxjs/toolkit";
import { RootState } from "store";
import { DettaglioCertificazioneReducerType } from "./types";

const dettaglioCertificazioneReducer = (state: RootState): DettaglioCertificazioneReducerType => state.dettaglioCertificazione;

export const dettaglioCertificazioneSelector = createSelector(
  dettaglioCertificazioneReducer,
  (state: DettaglioCertificazioneReducerType): DettaglioCertificazioneDto => {
    return state.dettaglioCertificazione;
  }
);

export const resultAvvioCertificazioneSelector = createSelector(
  dettaglioCertificazioneReducer,
  (state: DettaglioCertificazioneReducerType): CertificazioneEmailDto | void => {
    return state.resultAvvioCertificazione;
  }
);

export const storicoSmsCertificazioneEmailSelector = createSelector(
  dettaglioCertificazioneReducer,
  (state: DettaglioCertificazioneReducerType): CertificazioneCellulareDto[] => {
    return state.dettaglioCertificazioneEmail.certificazioniCellulare || [];
  }
);

export const dettaglioCertificazioneClienteSelector = createSelector(
  dettaglioCertificazioneReducer,
  (state: DettaglioCertificazioneReducerType): CertificazioneUtenteDto | undefined => {
    return state.dettaglioCertificazioneCliente;
  }
);

export const resultInvioEmailSelector = createSelector(
  dettaglioCertificazioneReducer,
  (state: DettaglioCertificazioneReducerType): CertificazioneEmailDto | undefined => {
    return state.resultInvioEmail;
  }
);

export const logCedacriSelector = createSelector(
  dettaglioCertificazioneReducer,
  (state: DettaglioCertificazioneReducerType): LogCertificazioneAnagrafeCedacriDto[] | undefined => {
    return state.logCedacri;
  }
);
